'use client';

import { NavLink } from './NavLink';
import { getAnchorIds, resolveHref } from './navigation.utils';
import { useScrollSpy } from '@/hooks';
import { usePathname } from 'next/navigation';
import { useSiteSettings } from '@/components/providers';
import { resolveAnchor } from '@/lib/utils';
import { cn } from '@/lib/tailwind';

type RestProps = {
    className?: string;
};

export function NavigationMain({ className }: RestProps) {
    const settings = useSiteSettings();
    const items = settings.navigation?.main ?? [];
    const pathname = usePathname();
    const anchorIds = getAnchorIds(items);
    const activeAnchorId = useScrollSpy({ ids: anchorIds });

    return (
        <nav className={className} aria-label="Main navigation">
            <ul className="flex gap-4 justify-end @min-[48rem]:gap-6">
                {items.map((item) => {
                    const href = resolveHref(item);
                    const anchor = resolveAnchor(item.anchor);
                    const isAnchor = !!anchor;
                    const isActive = isAnchor ? anchor === activeAnchorId : pathname === href;

                    return (
                        <li key={item._key}>
                            <NavLink
                                item={item}
                                isActive={isActive}
                                className={cn('text-xs font-semibold uppercase @min-[48rem]:text-sm', isActive && 'underline')}
                            />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
